<div class="backpage-wrapper">
  <div class="individual-sub-container">
    <div class="header">
      <img
        src="../../../../assets/Logos/Overtur Logo.png"
        alt="overtur orange logo"
        width="60"
        height="50"
      />
      <h1>Overtur Subscriptions</h1>
    </div>
    <div *ngIf="subscriptionDetails.warningNote" class="warning-note">
      <h4>{{ subscriptionDetails.warningNote }}</h4>
    </div>
    <div class="top-row-section">
      <div class="current-sub-details" *ngIf="subscriptionDetails">
        <div class="company-section">
          <div class="section-header-current">
            <div class="header-left">
              <mat-icon>info_outline</mat-icon>
              <h3>Current Subscription Details</h3>
            </div>
            <div class="header-right">
              <h4>Status:</h4>
              <mat-chip
                [ngClass]="{
                  'chip-active':
                    subscriptionDetails.subscriptionStatus === 'Active',
                  'chip-failed':
                    subscriptionDetails.subscriptionStatus === 'Failed',
                  'chip-expired':
                    subscriptionDetails.subscriptionStatus === 'Expired',
                  'chip-revoked':
                    subscriptionDetails.subscriptionStatus === 'AutoRevoked'
                }"
              >
                {{
                  subscriptionDetails.subscriptionStatus || "No Status Provided"
                }}
              </mat-chip>
            </div>
          </div>
          <div class="current-sub-section-content">
            <div class="current-sub-row">
              <div class="site-name">
                <h4>Subscription ID</h4>
                <p>
                  {{ subscriptionDetails.subscriptionId || "Not Available" }}
                </p>
              </div>
              <div class="property-address">
                <h4>SKU</h4>
                <p>{{ subscriptionDetails.sku || "Not Available" }}</p>
              </div>
              <div class="property-address">
                <h4>Start Date</h4>
                <p>{{ subscriptionDetails.startDate | date: "MM/dd/yyyy" }}</p>
              </div>
            </div>
            <div class="current-sub-row">
              <div class="property-address">
                <h4>Description</h4>
                <p>
                  {{ subscriptionDetails.subscriptionPlan || "Not Available" }}
                </p>
              </div>
              <div class="property-address">
                <h4>Wholesaler Account</h4>
                <p>
                  {{ subscriptionDetails.wholeSalerAccount || "Not Available" }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="zendesk-section" *ngIf="subscriptionDetails">
        <div class="section-header">
          <mat-icon>support_agent</mat-icon>
          <h3>Zendesk Information</h3>
        </div>
        <div class="zendesk-section-content">
          <div class="site-name">
            <h4>Zendesk Ticket ID</h4>
            <p *ngIf="!subscriptionDetails.zendeskTicketId">Not Available</p>
            <a
              *ngIf="
                subscriptionDetails.zendeskTicketId &&
                subscriptionDetails.zendeskTicketUrl
              "
              [href]="subscriptionDetails.zendeskTicketUrl"
              target="_blank"
              rel="noopener noreferrer"
            >
              #{{ subscriptionDetails.zendeskTicketId }}
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="top-2-section">
      <div class="company-section">
        <div class="section-header">
          <mat-icon>corporate_fare</mat-icon>
          <h3>Company Information</h3>
        </div>
        <div class="company-section-content">
          <div class="site-name">
            <h4>End User Email</h4>

            <div class="edit-icon">
              <p>
                {{ subscriptionDetails.endUserEmail || "Not Available" }}
              </p>
              <button
                *ngIf="!isEditingEmail"
                mat-icon-button
                (click)="toggleEmailEdit()"
              >
                <mat-icon>edit_outline</mat-icon>
              </button>
            </div>
            <div class="property-address">
              <h4>Company Info</h4>

              <p>
                {{
                  originalCompanyName ||
                    subscriptionDetails.endUserCompanyName ||
                    "Not Available"
                }}
              </p>
              <p>
                {{
                  originalCompanyAccountId ||
                    subscriptionDetails.endUserCompanyAccountId ||
                    "Not Available"
                }}
              </p>
            </div>
            <div class="new-email-1" *ngIf="isEditingEmail">
              <mat-form-field
                class="full-width"
                appearance="outline"
                floatLabel="always"
              >
                <mat-label>Enter new email</mat-label>
                <input
                  matInput
                  [(ngModel)]="newEmail"
                  (ngModelChange)="onEmailModelChange($event)"
                />
              </mat-form-field>
              <button
                *ngIf="isEditingEmail"
                mat-icon-button
                (click)="cancelEmailEdit()"
                color="warn"
              >
                <mat-icon>close</mat-icon>
              </button>
            </div>
            <div
              class="property-address"
              *ngIf="
                emailChanged() &&
                isEmailValid &&
                (newCompanyName || newCompanyAccountId)
              "
            >
              <h4>New Company Info</h4>
              <p>{{ newCompanyName || "Not Available" }}</p>
              <p>{{ newCompanyAccountId || "Not Available" }}</p>
            </div>
            <div *ngIf="!isEmailValid" style="color: red">
              <p *ngIf="emailValidationError">{{ emailValidationError }}</p>
              <ul *ngIf="emailValidationErrors.length">
                <li *ngFor="let err of emailValidationErrors">{{ err }}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="renewal-section">
        <div class="section-header">
          <mat-icon>calendar_month</mat-icon>
          <h3>Renewal Date</h3>
        </div>
        <div class="renewal-section-content">
          <div class="site-name">
            <h4>Renewal Date</h4>
            <div class="edit-icon" *ngIf="!isEditingRenewalDate">
              <p>{{ subscriptionDetails.renewalDate | date: "MM/dd/yyyy" }}</p>
              <button
                *ngIf="subscriptionDetails.renewalDate"
                mat-icon-button
                (click)="toggleRenewalDateEdit()"
              >
                <mat-icon>edit_outline</mat-icon>
              </button>
            </div>
            <div class="new-email" *ngIf="isEditingRenewalDate">
              <div class="date-input-row">
                <mat-form-field
                  class="full-width"
                  appearance="outline"
                  floatLabel="always"
                >
                  <mat-label>Select New Renewal Date</mat-label>
                  <input
                    matInput
                    [matDatepicker]="picker"
                    [(ngModel)]="newRenewalDate"
                    [min]="minRenewalDate"
                  />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="picker"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
                <button
                  *ngIf="isEditingRenewalDate"
                  mat-icon-button
                  (click)="cancelRenewalDateEdit()"
                  color="warn"
                >
                  <mat-icon>close</mat-icon>
                </button>
              </div>
              <mat-form-field
                class="full-width"
                appearance="outline"
                floatLabel="always"
              >
                <mat-label>Reason for Change</mat-label>
                <textarea
                  matInput
                  rows="4"
                  [(ngModel)]="renewalDateChangeReason"
                  placeholder="Enter reason for change"
                ></textarea>
              </mat-form-field>
              <div
                *ngIf="!isReasonValid && renewalDateChanged()"
                style="color: red"
              >
                Please enter a reason for changing the renewal date.
              </div>
            </div>
          </div>
          <div class="property-address">
            <h4>Renewal Date Notes</h4>
            <p>{{ subscriptionDetails.renewalDateNotes || "Not Available" }}</p>
          </div>
        </div>
      </div>
      <div class="po-section">
        <div class="section-header">
          <mat-icon>receipt</mat-icon>
          <h3>Current PO Information</h3>
        </div>
        <div class="po-section-content">
          <div class="po-2">
            <div class="site-name">
              <h4>PO Number</h4>
              <p>{{ subscriptionDetails.poNumber || "Not Available" }}</p>
            </div>
            <div class="property-address">
              <h4>Invoice Number</h4>
              <p>{{ subscriptionDetails.invoiceNumber || "Not Available" }}</p>
            </div>
            <div class="property-info">
              <h4>Order Date</h4>
              <p>{{ subscriptionDetails.orderDate | date: "MM/dd/yyyy" }}</p>
            </div>
          </div>
          <div class="po-2">
            <div class="property-info">
              <h4>Sales Order Number</h4>
              <p>{{ subscriptionDetails.soNumber || "Not Available" }}</p>
            </div>
            <div class="property-info">
              <h4>Amount</h4>
              <p>${{ subscriptionDetails.amount || "Not Available" }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="current-sub-details">
      <div class="company-section">
        <div class="section-header">
          <mat-icon>history</mat-icon>
          <h3>Subscription History</h3>
        </div>
        <div
          class="table-container"
          *ngIf="dataSource.data.length; else noHistory"
        >
          <mat-table [dataSource]="dataSource" matSort class="mat-elevation-z2">
            <!-- End User Email Column -->
            <ng-container matColumnDef="endUserEmail">
              <mat-header-cell *matHeaderCellDef mat-sort-header
                >End User Email</mat-header-cell
              >
              <mat-cell *matCellDef="let element">{{
                element.endUserEmail || "N/A"
              }}</mat-cell>
            </ng-container>

            <!-- SKU Column -->
            <ng-container matColumnDef="sku">
              <mat-header-cell *matHeaderCellDef mat-sort-header
                >SKU</mat-header-cell
              >
              <mat-cell *matCellDef="let element">{{
                element.sku || "N/A"
              }}</mat-cell>
            </ng-container>

            <!-- PO Number Column -->
            <ng-container matColumnDef="poNumber">
              <mat-header-cell *matHeaderCellDef mat-sort-header
                >PO Number</mat-header-cell
              >
              <mat-cell *matCellDef="let element">{{
                element.poNumber || "N/A"
              }}</mat-cell>
            </ng-container>

            <!-- SO Number Column -->
            <ng-container matColumnDef="soNumber">
              <mat-header-cell *matHeaderCellDef mat-sort-header
                >SO Number</mat-header-cell
              >
              <mat-cell *matCellDef="let element">{{
                element.soNumber || "N/A"
              }}</mat-cell>
            </ng-container>

            <!-- Invoice Number Column -->
            <ng-container matColumnDef="invoiceNumber">
              <mat-header-cell *matHeaderCellDef mat-sort-header
                >Invoice Number</mat-header-cell
              >
              <mat-cell *matCellDef="let element">{{
                element.invoiceNumber || "N/A"
              }}</mat-cell>
            </ng-container>

            <!-- Amount Column -->
            <ng-container matColumnDef="amount">
              <mat-header-cell *matHeaderCellDef mat-sort-header
                >Amount</mat-header-cell
              >
              <mat-cell *matCellDef="let element"
                >${{ element.amount || "N/A" }}</mat-cell
              >
            </ng-container>

            <!-- Start Date Column -->
            <ng-container matColumnDef="startDate">
              <mat-header-cell *matHeaderCellDef mat-sort-header
                >Start Date</mat-header-cell
              >
              <mat-cell *matCellDef="let element">{{
                element.startDate | date: "MM/dd/yyyy"
              }}</mat-cell>
            </ng-container>

            <!-- End Date Column -->
            <ng-container matColumnDef="endDate">
              <mat-header-cell *matHeaderCellDef mat-sort-header
                >End Date</mat-header-cell
              >
              <mat-cell *matCellDef="let element">{{
                element.endDate | date: "MM/dd/yyyy"
              }}</mat-cell>
            </ng-container>

            <!-- Subscription Status Column -->
            <ng-container matColumnDef="subscriptionStatus">
              <mat-header-cell *matHeaderCellDef mat-sort-header
                >Status</mat-header-cell
              >
              <mat-cell *matCellDef="let element">
                <mat-chip
                  [ngClass]="{
                    'chip-active': element.subscriptionStatus === 'Active',
                    'chip-inactive': element.subscriptionStatus === 'Inactive',
                    'chip-expired': element.subscriptionStatus === 'Expired',
                    'chip-autorevoked':
                      element.subscriptionStatus === 'AutoRevoked'
                  }"
                >
                  {{ element.subscriptionStatus || "No Status Provided" }}
                </mat-chip>
              </mat-cell>
            </ng-container>

            <!-- Header and Row -->
            <mat-header-row
              *matHeaderRowDef="displayedColumns"
            ></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
          </mat-table>

          <mat-paginator
            [pageSizeOptions]="[5, 10, 20]"
            showFirstLastButtons
          ></mat-paginator>
        </div>

        <ng-template #noHistory>
          <div class="no-history">
            <p>No subscription history available.</p>
          </div>
        </ng-template>
      </div>

      <div>
        <div class="button-container">
          <button
            mat-flat-button
            color="secondary"
            [routerLink]="['/overtur-admin-subscriptions']"
          >
            <mat-icon>keyboard_backspace</mat-icon>
            Back
          </button>
          <button
            mat-flat-button
            color="primary"
            (click)="updateOverturSubscription()"
            [disabled]="
              !hasChanges ||
              !isReasonValid ||
              isEmailValidating ||
              (emailChanged() && !isEmailValid)
            "
          >
            Update
          </button>
        </div>
        <div *ngIf="updateError" class="warning-note">
          <h4>{{ updateError }}</h4>
        </div>
      </div>
    </div>
  </div>
</div>
